import { window } from '../../../globals';
import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';

async function removeOrganizationLogo(): Promise<void> {
  // TODO: Implement proper logo removal endpoint for new streaming approach
  // The old endpoint '/api/organization/logo' with { unset: true } was deprecated
  throw new Error('Logo removal not yet implemented with new streaming endpoints');
}

/**
 * Hook for removing organization logo.
 */
export default function useRemoveOrganizationLogo() {
  return useToastedMutation({
    mutationFn: removeOrganizationLogo,
    successToastMessage: 'Logo removed successfully',
    errorToastMessage: 'Failed to remove logo',
    onSuccess: () => {
      if (window.user && window.user.organization) {
        window.user.organization.image = undefined;
      }
      queryClient.invalidateQueries({ queryKey: ['organization'] });
    },
  });
}
